import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetCashtagUrlEnabledRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetCashtagUrlEnabledResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setCashtagUrlEnabled = (request: SetCashtagUrlEnabledRequest, options?: CashRequestOptions) =>
  post<SetCashtagUrlEnabledRequest, SetCashtagUrlEnabledResponse>('/2.0/cash/set-cashtag-url-enabled', request, {
    ...options,
    rejectOnError: true,
  })
